import React, { Fragment } from "react";
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Paper, List, ListItem, ListItemAvatar, ListItemText, Typography, Stack } from '@mui/material';
import Payments from "../../../../components/Connect/Payments";
import PaymentsIcon from '@mui/icons-material/Payments';

function PaymentHistory({ accountId, embedded = false }) {
  const theme = useTheme();

  if (embedded) {
    return (
      <Box sx={{ width: "100%" }}>
        <Payments accountId={accountId}/>
      </Box>
    );
  }

  return (
    <Paper
        variant="outlined"
        sx={{ p: 0, mb:2, display: 'block', borderRadius: '8px', borderWidth: '1px', backgroundColor: theme.palette.background.paper }}
    >
        <Box p={0} style={{ textAlign: 'center', width: '100%'}}>
            <List component="nav" sx={{p: 0}}>
                <ListItem sx={{p: 2, borderRadius: '8px'}}>
                    <ListItemAvatar sx={{ mr: 'auto', minWidth: '48px' }}>
                        <Avatar variant="rounded" sx={{ height: '32px', width: '32px', bgcolor: theme.palette.grey[700] }}>
                            <PaymentsIcon fontSize="small"/>
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText 
                    primary={
                        <Fragment>
                            <Typography
                                component="span"
                                sx={{ color: 'text.primary', display: 'inline', fontWeight: 500, fontSize: '16px' }}
                            >
                                Payment history
                            </Typography>
                        </Fragment>
                    }/>
                </ListItem>
            </List>
        </Box>
        <Box p={0} style={{ textAlign: 'center', width: '100%' }}>
            <Stack sx={{ p: 2, pt: 0, display: 'block'}}>
              <Payments accountId={accountId}/>
            </Stack>
        </Box>
    </Paper>
  );
}

export default PaymentHistory;
